<template>
  <div class="report-wrap">
    <div class="report-item report-item_admin" @click="onClick">
        <v-row no-gutters class="align-center report-item__row">
          <v-col sm="3" cols="12" class="report-item__text report-item__text_bold pr-5">
            {{report.name}}
          </v-col>
          <v-col sm="3" lg="5" cols="12" class="report-item__text pr-5">
            {{report.description}}
          </v-col>
          <v-col sm="3" lg="2" cols="12" class="report-item__text report-item__right">
            <v-switch 
            v-model="report.visible"
            :label="report.visible ? 'Опубликован' : 'Не опубликован'"
            :color="'green'"
            :class="'switch-visible label-icon-bold'"
            hide-details
            @click.stop.prevent="changeVisible"
            inset></v-switch>
          </v-col>
          <v-col sm="3" lg="2" cols="12" class="report-item__text report-item__right">
            <v-btn class="ma-2 label-icon-bold btn-delete" @click.stop.prevent="isDeletePopup = true" text :color="'#1C1B28'" small>
              <v-icon left size="25" :color="'green'">{{mdiWindowClose}}</v-icon> Удалить отчет
            </v-btn>
          </v-col>
        </v-row>
    </div>

    <v-expansion-panels>
      <v-expansion-panel class="report-item report-item_mobile report-status--default">
        <v-expansion-panel-header expand-icon="mdi-menu-down">
          <v-container>
            <v-row>
              <v-col md="2" sm="12" cols="12" class="d-flex align-center">
                <div class="report-item-icon-box">
                  <img class="report-item__icon" src="@/assets/icons/calendar.svg"/>
                </div>
                <div class="report-item__text">{{report.name}}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container>
            <v-row>
              <v-col md="3" sm="12" cols="12" class="d-flex">
                <div class="report-item__text">{{report.description}}</div>
              </v-col>
              <v-col md="3" sm="12" cols="12" class="d-flex report-item__text">
                <v-switch 
                  v-model="report.visible"
                  :label="report.visible ? 'Опубликован' : 'Не опубликован'"
                  :color="'green'"
                  hide-details
                  @click.stop.prevent="changeVisible"
                  inset></v-switch>
              </v-col>
              <v-col md="3" sm="12" cols="12" class="d-flex report-item__text">
                <a href="/" class="report-item__text report-item__text_color"
               @click.stop.prevent="isDeletePopup = true">Удалить</a>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <a href="/" @click.stop.prevent="onClick" class="report-item__button">Подробнее</a>
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-overlay :value="isDeletePopup" :dark="false">
      <div class="white-container">
        <ReportDeletePopup @onOk="deleteReport" @onClose="isDeletePopup = false" />
      </div>
    </v-overlay>

  </div>
</template>

<script>
  import Vue from 'vue';
  import { mdiWindowClose } from '@mdi/js';

  import {ReportItemModel} from '@/models/reports';
  import {formatDate, formatTime} from '@/helpers/localization';
  import ReportDeletePopup from '@/components/Administration/Report/ReportDeletePopup.vue';

  export default Vue.extend({
    components: {
      ReportDeletePopup,
    },
    props: {
      report: ReportItemModel,
    },
    data() {
      return {
        isDeletePopup: false,
        mdiWindowClose,
      };
    },
    methods: {
      onClick() {
        this.$emit('click');
      },
      deleteReport() {
        this.isDeletePopup = false;
        this.$store.dispatch('adminReports/deleteReport', this.report.id);
      },
      changeVisible() {
        const formData = new FormData();
        formData.append('request', JSON.stringify({
          ...this.report,
          visible: !this.report.visible,
        }));

        this.$store.dispatch('adminReports/editReport', formData)
          .then(() => this.$emit('refreshReports'));
      },
    },
  });
</script>

<style scoped lang="scss" src="@/styles/service/reports-item.scss"></style>
